<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Permissions
              <router-link :to="{ name: 'PermissionForm' }" class="btn ml-auto">
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Permissions</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(permissions.data) && is_loading == false"
          >
            <button
              type="button"
              class="btn btn-info"
              @click="show_filter = !show_filter"
            >
              <i class="fa fa-filter"></i>Filter
            </button>
            <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="setFilters" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-row">
                    <div class="col-md-12">
                      <div class="form-group form-row">
                        <label class="col-md-3 col-form-label" for="name"
                          >Name</label
                        >
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            v-model="filter.name"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group form-row">
                        <label class="col-md-3 col-form-label" for="http_path"
                          >Http Path</label
                        >
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control"
                            id="http_path"
                            v-model="filter.http_path"
                            placeholder="HTTP PATH"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row justify-content-end">
                        <div class="col-md-9">
                          <button type="submit" class="btn mr-3">
                            <i class="icon-search"></i> Search
                          </button>
                          <button
                            type="reset"
                            class="btn btn-outline"
                            @click="resetFilter()"
                          >
                            <i class="icon-refresh"></i>
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <div class="card-body">
            <div v-if="!_.isEmpty(permissions.data) && is_loading == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 10px">ID</th>
                      <th>
                        Slug
                        <sort-icons :_sort="'slug'" />
                      </th>
                      <th>
                        Name
                        <sort-icons :_sort="'name'" />
                      </th>
                      <th>Method</th>
                      <th>Route</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="permissions-permissions">
                    <tr v-for="(val, index) in permissions.data">
                      <td>{{ val.id }}</td>
                      <td>{{ val.slug }}</td>
                      <td>{{ val.name }}</td>
                      <td>
                        <span
                          class="badge"
                          v-for="(methodValue, roleIndex) in val.http_method"
                          >{{ methodValue }}</span
                        >
                      </td>
                      <td>{{ val.http_path }}</td>
                      <td>{{ val.created_at }}</td>
                      <td>{{ val.updated_at }}</td>
                      <td class="text-right">
                        <router-link
                          :to="{
                            name: 'PermissionView',
                            params: { id: val.id },
                          }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>
                        <router-link
                          :to="{
                            name: 'PermissionEdit',
                            params: { id: val.id },
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="destroy(val.id, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>

            <div
              class="p-4"
              v-if="_.isEmpty(permissions.data) && is_loading == false"
            >
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>
          <div
            :class="{ 'card-footer': permissions.total > permissions.per_page }"
          >
            <vue-pagination
              :pagination="permissions"
              v-if="permissions.total > permissions.per_page"
              @paginate="getPermissions()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { PermissionAPI } from "@/services/api";
import axios from "axios";
import { Notification } from "element-ui";

// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "PermissionList",
  metaInfo: {
    title: "Permission | Dotlines",
  },
  components: {
    // DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    permissions: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
    },
    show_filter: false,
    filter: {
      name: "",
      http_path: "",
    },
    is_loading: false,
  }),
  watch: {
    "$route.query"() {
      this.getPermissions();
    },
  },
  mounted: function () {
    /* if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click')
    } */
    this.getPermissions();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
    });
  },
  methods: {
    exportFile: function () {
      this.is_loading = true;
      const query = { ...this.filter, ...this.$route.query };
      axios
        .get("/admin-permissions-export", {
          params: query,
          responseType: "blob",
        })
        .then((response) => {
          // console.log(response.data);
          fileDownload(response.data, "admin-permissions.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    getPermissions() {
      this.is_loading = true;
      const query = { ...this.filter, ...this.$route.query };
      PermissionAPI.index(query)
        .then((permissions) => {
          this.permissions = permissions;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    destroy: function (id, index) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.is_loading = true;
            PermissionAPI.destroy(id)
              .then((response) => {
                this.permissions.data.splice(index, 1);
                this.permissions.total--;
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                console.log("Could not delete this:: ", error);
                this.$swal.fire("Failed!", "Failed to delete.", "error");
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        });
    },
    async setFilters() {
      await this.$router
        .push({
          path: this.$route.path,
          query: this.filter,
        })
        .catch();
    },
    resetFilter() {
      this.filter = {};
      this.$router.push({ path: this.$route.path }).catch();
      this.$root.$emit("show-icon");
      this.show_filter = false;
    },
  },
};
</script>
